export default __webpack_public_path__ + "static/media/bookmark-lock.fde4e9ae.svg";